import { render, staticRenderFns } from "./view.vue?vue&type=template&id=77bb7358"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77bb7358')) {
      api.createRecord('77bb7358', component.options)
    } else {
      api.reload('77bb7358', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=77bb7358", function () {
      api.rerender('77bb7358', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/apply/view.vue"
export default component.exports